import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario1 from "./Scenario1";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";

export default class Scenario1Part2 extends BaseScenarioPart<CalmBaseScenario> {

	chapterIds = {
		scenario1_2a_s3: 'CALM - Scenario 1 - 2A - Segment 3',
		scenario1_2a_s4: 'CALM - Scenario 1 - 2A - Segment 4',
		scenario1_2a_s5: 'CALM - Scenario 1 - 2A - Segment 5',
		scenario1_2a_s6: 'CALM - Scenario 1 - 2A - Segment 6'
	}

	private partIndx = 1;

	constructor(scenario: Scenario1, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario1/calm-scenario1-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part2.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MirandaApproaches();
	}

	private segment1Step1MirandaApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Speak with RN Miranda');
		this.playVideoChapter(this.chapterIds.scenario1_2a_s3, () => { //a.	Miranda approaches and talks about Jane - to Response UI
			context.scenario.updateObjective('');
			context.segment1Step2MirandaDialogue();
		});
	}

	private segment1Step2MirandaDialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		var elaborateMoreOption = "Thanks, Miranda. Could you please elaborate a little more?";
		this.scenario.dialog(
			'CN-C02-L1-000a',
			[{
				text: elaborateMoreOption,
				isCorrect: false,
				scoreType: ScoreType.Ok
			}, {
				text: 'Thanks, Miranda. I’ll go talk to Jane and find out what’s going on.',
				isCorrect: true,
				scoreType: ScoreType.Best
			}, {
				text: 'Thanks, Miranda. I’m going to call our Nurse Manager and see what she recommends.',
				feedback: 'It’s premature to call the Nurse Manager. You need to talk to Jane. Maybe Miranda was mistaken. Remember, as a Charge Nurse, you have to advocate for your staff.',
				isCorrect: false,
				scoreType: ScoreType.Worst
			}],
			(selectedOption: DialogueUIOptionConfig) => {

				if(selectedOption.text.indexOf(elaborateMoreOption) !== -1) {
					context.segment1Step2MirandaElaborates();
				} else {
					context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1WalkToJane(), context.partIndx);
				}
			}
		);		
	}

	private segment1Step2MirandaElaborates() {
		this.scenario.destroyAllUIInstances();
		//this.scenario.stopAmbientLoop();
		var context = this;
		context.scenario.updateObjective('Listen to Miranda for more details');
		this.playVideoChapter(this.chapterIds.scenario1_2a_s4, () => { //a.	Miranda elaborates more about Jane - to Response UI
			context.scenario.updateObjective('');
			context.segment1Step2MirandaElaborateDialogue();
		});
	}

	private segment1Step2MirandaElaborateDialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		this.scenario.dialog(
			'CN-C02-L1-010a',
			[{
				text: 'I’ll go talk to Jane and find out what’s going on.',
				isCorrect: true,
				scoreType: ScoreType.Best
			}, {
				text: 'I\'m going to have to send her home.',
				feedback: 'Before jumping to conclusions, you need to talk to Jane. Maybe Miranda was mistaken. Alternatively, Jane could have a medical condition such as stroke or hypoglycemia presenting these types of symptoms. Remember, as a Charge Nurse, you need to ensure patient safety while supporting your staff.',
				isCorrect: false,
				scoreType: ScoreType.Ok
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1WalkToJane(), context.partIndx);
			}
		);
	}

	private segment2Step1WalkToJane() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('Locate and speak with RN Jane');
		this.playVideoChapter(this.chapterIds.scenario1_2a_s5, () => { //a.	Charge Nurse walks to and listens to Jane speak - to Response UI
			context.segment2Step2JaneDialogue();
		});
	}

	private segment2Step2JaneDialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		this.scenario.dialog(
			'CN-C02-L1-020b',
			[{
				text: 'I think I need to let Nurse Manager Trista know that we need to make sure you’re okay.',
				isCorrect: true,
				scoreType: ScoreType.Best
			}, {
				text: 'I’m so sorry. I’m mistaken. Just go back to work.',
				feedback: 'Even though Jane says she is okay, as a Charge Nurse, you need to make sure she is in fact okay. Patient safety depends on this.',
				isCorrect: false,
				scoreType: ScoreType.Worst
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1GoToNurseStation(), context.partIndx);
			}
		);
	}

	private segment3Step1GoToNurseStation() {
		this.scenario.destroyAllUIInstances();
		var context = this;
				context.scenario.destroyAllUIInstances();
				context.scenario.updateObjective('Speak with the Nurse Manager, then go to Nurse\'s Station Computer');
				context.playVideoChapter(this.chapterIds.scenario1_2a_s6, () => { //a.	Nurse Manager Trist speaks on phone, CN returns to nurse station - to computer Report UI
					context.scenario.updateObjective('');
					context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
					context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
						title: 'How would you re-staff RN Jane\'s patients?',
						options: [
							{
								text: 'Call for additional staffing support.',
								isCorrect: true,
								scoreType: ScoreType.Best,
								feedback: 'Since RN Jane’s condition was determined at the start of a shift, it may be best to call for additional support since being overloaded for an entire shift could risk patient safety. However, if this is not an option, you may have to share amongst the staff, including yourself.'
							},
							{
								text: 'Divide the patients amongst the remaining staff for the rest of the shift.',
								isCorrect: false,
								scoreType: ScoreType.Zero,
								feedback: 'This may not the best solution, but a viable short-term solution. Being overloaded for an entire shift could risk patient safety.'
							},
							{
								text: 'Take Jane’s patients yourself since you have no patients.',
								isCorrect: false,
								scoreType: ScoreType.Zero,
								feedback: 'This may not be the best solution, but a viable short-term solution. If you take on Jane’s patients you will not have time to perform your duties as the Charge Nurse for the entire shift, which may hinder provision of patient care. '
							},
							{
								text: 'Have LPN Jamie take all of Jane’s patients.',
								isCorrect: false,
								scoreType: ScoreType.Zero,
								feedback: 'This is not a good option. LPN Jamie is not qualified to handle the same responsibilities as an RN. '
							}
						],
						onChoiceSelected: (selectedOption: DialogueUIOptionConfig) => {
							context.scenario.evaluateAnswer(selectedOption, () => {}, context.partIndx);
						},
						onClosed: (config: NurseStationComputerSingleQustionUIConfig) => {
							context.showNurseStationComputer();
						},
					}
				)
			}
		);
	}

	private showNurseStationComputer() {
		var context = this;
		context.scenario.destroyAllUIInstances();
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'Nothing to add to report'
				},
				{
					title: '24 Hour',
					description: 'Nothing to add to report.'
				},
				{
					title: 'End of Shift',
					description: 'Re-staffing was accomplished to replace one RN.'
				}
			],
			review: {
				text: 
				`
				<p class="regular-description-font" style="margin: 0">

					A Charge Nurse may be faced with many dilemmas as part of the job, but patient and staff 
					safety should be kept paramount. <br /><br />
					
					<span style="color: rgb(222, 225, 156)">In this scenario, a staff member was unable to perform her duties.</span> In some cases, the staff 
					member could be under the influence but in other cases, the staff member may in fact have 
					an acute disease process that needs attention. <br /><br />
					
					A Nurse Supervisor or Nurse Manager needs to be called in quickly to handle this 
					managerial situation. Using <span style="color: rgb(222, 225, 156)">Employee Health</span>  may be one option to ensure the safety of the 
					staff member. In other cases, a staff member may come to work ill or with an injury that 
					could be equally detrimental to the employee’s and unit’s safety. <br /><br />
					
					It’s your job to <span style="color: rgb(222, 225, 156)">assess each situation</span> as it arises, <span style="color: rgb(222, 225, 156)">follow policy</span>, and <span style="color: rgb(222, 225, 156)">maintain unit safety.</span>
				</p>
				`
			},
			reflects: [
				{
					title: 'What is the policy at your facility when handling an incapacitated staff member? Who should you notify?',
					answer: ''
				},
				{
					title: 'What do you say to the other staff members and to the staff member’s assigned patients?',
					answer: ''
				},
				{
					title: 'How do you handle the loss of a staff member when the remaining staff is already at maximum patient load?',
					answer: ''
				},
				{
					title: 'Would your response be different if the staff member came in sick or with an ankle brace? ',
					answer: ''
				},
				{
					title: 'Do you have an employee assistance program at your facility?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			} 
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			context.onDone();
		});
	}
}